




import { Vue, Component } from 'vue-property-decorator';

@Component
export default class JobList extends Vue {
  private headers = [
    { text: 'Name', value: 'name' },
    { text: 'Time Left', value: 'time-left' },
    { text: 'Status', value: 'status' }
  ];

  private joblist = [];
}
